<button type="button" class="btn btn-info"
        popover="Vivamus sagittis lacus vel augue laoreet rutrum faucibus.">
  I have component level styling
</button>
